import React from "react";
import { styled } from "@mui/material/styles";
import { Box, LinearProgress, linearProgressClasses, Typography } from "@mui/material";
import { formatPercentValue } from "@utils";

const ProgressBar = styled(LinearProgress, {
  shouldForwardProp: (prop) => !["hideLabel", "barColor", "barHeight", "barRadius"].includes(prop)
})(({ theme, barColor, barHeight = 10, barRadius = 30 }) => ({
  borderRadius: barRadius,
  height: barHeight,
  [`&.${linearProgressClasses.root}`]: {
    backgroundColor: theme.palette.grey[200]
  },
  [`& .${linearProgressClasses.bar}`]: {
    backgroundColor: barColor ?? theme.palette.secondary.main,
    borderRadius: barRadius
  }
}));

const HyroLinearProgressBar = (props) => {
  const { hideLabel, labelPosition = "right", ...otherProps } = props;

  const labelContent = !hideLabel ? (
    <Box sx={{ minWidth: 35 }}>
      {props.value > 0 ? (
        <Typography variant="body2">{formatPercentValue(props.value)}</Typography>
      ) : (
        <Box sx={{ width: 24, height: "1px", backgroundColor: "grey.400" }} />
      )}
    </Box>
  ) : null;

  const progressBar = (
    <Box sx={{ width: "100%" }}>
      <ProgressBar variant="determinate" {...otherProps} />
    </Box>
  );

  return (
    <Box sx={{ display: "flex", alignItems: "center", width: "100%", mr: 3, gap: 3 }}>
      {labelPosition === "left" && labelContent}
      {progressBar}
      {labelPosition === "right" && labelContent}
    </Box>
  );
};

export default HyroLinearProgressBar;
